export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13340.6044701f.jpg";